import { render } from "./RoomSpecificBoard.vue?vue&type=template&id=2f122eb9&scoped=true"
import script from "./RoomSpecificBoard.vue?vue&type=script&lang=js"
export * from "./RoomSpecificBoard.vue?vue&type=script&lang=js"

import "./RoomSpecificBoard.vue?vue&type=style&index=0&id=2f122eb9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f122eb9"]])

export default __exports__